import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

interface BoxProps {
	$textColor: string;
	$backgroundColor: string;
}

export const box = styled.div<BoxProps>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem 1.5rem;
	background-color: ${(props) => props.$backgroundColor};

	> p {
		width: 100%;
		font-size: 1.4rem;
		text-align: center;
		color: ${(props) => props.$textColor};
	}
`;
